import { createSelector } from 'reselect';

import { isMobileUserAgent } from '../utils/isMobileUserAgent.mjs';
import { isNode } from '../utils/environment.mjs';
import { isRebranded } from '../utils/isRebranded.mjs';
import { selectIsInProductMagazine } from './selectIsInProductMagazine.mjs';
import { selectEdition } from './selectEdition.mjs';

const selectHasClosedDownloadAppBanner = (state) =>
  state.downloadAppBanner.hasClosedDownloadAppBanner;

const selectIsEligibleForDownloadAppBannerExperiment = createSelector(
  selectIsInProductMagazine,
  selectEdition,
  selectHasClosedDownloadAppBanner,
  (isInProduct, edition, hasClosed) => {
    if (isNode()) {
      return false;
    }
    return (
      !hasClosed &&
      !isInProduct &&
      edition === 'en' &&
      isRebranded &&
      isMobileUserAgent(navigator.userAgent)
    );
  },
);

export { selectHasClosedDownloadAppBanner, selectIsEligibleForDownloadAppBannerExperiment };
